import {
    CollectionPaymentSourceType,
    formatDate,
    ListProviderCollectionPaymentsRequest,
    ProviderCollectionPayment,
} from '@enter/core';
import * as d3 from 'd3';
import { faker } from '@faker-js/faker';
import _ from 'lodash';
import { ClaimGenerator } from './claim.generator';
import { IItemListing } from './root.store';
import { waitForNoReason } from './util';
import { generateAddress, generateAmount, generateItemListing } from './util.generator';

export class PaymentGenerator {
    private claimGenerator: ClaimGenerator;
    public payments: ProviderCollectionPayment[] = [];

    // TODO: extract index/storeTo/loadFrom as utility class
    public index: Map<string, Map<string, string[]>> = new Map<string, Map<string, string[]>>();

    constructor(claimGenerator: ClaimGenerator) {
        this.claimGenerator = claimGenerator;
        this.generateEntities(11);
    }

    public async loadPaymentListing(
        lpgr: ListProviderCollectionPaymentsRequest,
    ): Promise<IItemListing<ProviderCollectionPayment> | undefined> {
        await waitForNoReason(400);
        return generateItemListing(lpgr, this.payments);
    }
    public async loadPayment(chargemasterId: string): Promise<ProviderCollectionPayment | undefined> {
        let chargemaster = _.find(this.payments, { id: chargemasterId });
        if (!chargemaster) {
            chargemaster = this.generateProviderCollectionPayment(chargemasterId);
        }
        return chargemaster;
    }

    private generateEntities(count: number = 3): void {
        _.times(count, () => this.generateProviderCollectionPayment());
    }

    private generateProviderCollectionPayment(id: string = faker.string.uuid()): ProviderCollectionPayment {
        const claim = _.sample(this.claimGenerator.claims);

        const payment = {
            id,
            created: formatDate(faker.date.past(), 'yyyy-MM-dd'),
            organization: faker.company.name(),
            first: faker.person.firstName(),
            middle: _.sample([undefined, faker.person.firstName()]),
            last: faker.person.lastName(),
                suffix: _.sample([undefined, faker.person.suffix()]),
            addresses: _.times(_.random(0, 2), () => generateAddress()),
            phone: faker.phone.number(),
            dob: formatDate(faker.date.past(), 'yyyy-MM-dd'),
            email: faker.internet.exampleEmail(),
            groupId: _.uniqueId('group'),
            collectedAmount: generateAmount(),
            feeAmount: generateAmount(),
            source: _.sample(CollectionPaymentSourceType),
            paymentDate: formatDate(this.recentDateAfter(new Date()), 'yyyy-MM-dd'),
            claimId: _.get(claim, 'id') as string,
            guarantorId: _.get(claim, 'guarantorId') as string,
        };
        this.payments.push(payment);
        return payment;
    }

    private recentDateAfter(startDate: Date, range: number = 7): Date {
        const endDate = d3.utcDay.offset(startDate, _.random(1, range));
        return faker.date.between({ from: startDate, to: endDate });
    }
}
